define("settings/routes/groups/trade", ["exports", "@ember/routing/route", "@ember/service", "@glimmer/tracking", "later/utils/object-promise-proxy"], function (_exports, _route, _service, _tracking, _objectPromiseProxy) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  0; //eaimeta@70e063a35619d71f0,"@ember/routing/route",0,"@ember/service",0,"@glimmer/tracking",0,"later/utils/object-promise-proxy"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let TradeRoute = _exports.default = (_class = class TradeRoute extends _route.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "settings", _descriptor2, this);
      _initializerDefineProperty(this, "store", _descriptor3, this);
      _initializerDefineProperty(this, "groups", _descriptor4, this);
    }
    async model() {
      const groups = this.settings.isAccountOwner ? await this.store.query('group', {
        filter: {
          account_id: this.auth.currentAccount.id
        }
      }) : [];
      await Promise.all(groups.map(group => {
        return (0, _objectPromiseProxy.arrayPromiseProxy)(group.get('linkinbioPages').toArray());
      }));
      return groups;
    }
    setupController(controller, model) {
      this.groups = model;
      const sortedGroups = this.groups.sortBy('name');
      controller.setProperties({
        groups: sortedGroups,
        temporaryGroups: sortedGroups
      });
    }
    deactivate() {
      this.controller.setProperties({
        movedSocialProfiles: [],
        movedSocialIdentities: [],
        profilesMovedBetweenGroups: []
      });
      this.groups.forEach(group => {
        group.set('temporaryIdentities', null);
        group.set('traded', null);
        const identitiesToDelete = [];
        group.socialIdentities.forEach(identity => {
          identity.set('temporaryProfiles', null);
          if (!identity.influencerId && identity.get('socialProfiles').length === 0) {
            identitiesToDelete.addObject(identity);
          }
        });
        identitiesToDelete.forEach(identity => {
          group.socialIdentities.removeObject(identity);
        });
      });
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "settings", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "groups", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  })), _class);
});